import React from 'react';
import { IonContent, IonItem, IonItemGroup, IonLabel, IonPage, useIonAlert } from '@ionic/react';
import { RouteComponentProps } from 'react-router';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { Modal } from 'antd';
import { axius, func, types } from 'utils';
import { Header, IonLoading } from 'components';

import './_User.scss';

// user forms
const FormEmail = React.lazy(() => import('./FormEmail'));
const FormPhone = React.lazy(() => import('./FormPhone'));
const FormProfile = React.lazy(() => import('./FormProfile'));

interface Props extends RouteComponentProps, types.StateProps { };
const User: React.FC<Props> = props => {
    const [presentAlert] = useIonAlert();

    const state = useSelector((e: types.StateProps) => e);

    const { _auth: { user } } = state;

    const [edit, setEdit] = React.useState('');
    const [loading, setLoading] = React.useState('');

    React.useEffect(() => {
        if (func.getStorage('defaultPWD')) {
            setEdit(`password`);
        }
    }, []);

    const lists = [
        {
            key: 'profile',
            label: `
                <div>Edit Profile Details<br /> 
                    <div class="text-muted small mt-2">
                        ${user.name} • ${func.ucWords(user.gender || 'Gender')} • ${user.birthDate ? moment(user.birthDate).format('LL') : 'Birth date'}
                    </div>
                </div>
            `,
        },
        { key: 'phone', label: `<div>Edit Phone Number <br /> <div class="text-muted small mt-2">${func.format.phoneNumber(user.phoneNumber)}</div></div>`, },
        { key: 'email', label: `<div>Edit Email Address <br /> <div class="text-muted small mt-2">${user.email || 'N/A'}</div></div>`, },
        { key: 'logout', label: `<div>Log out</div>`, },
    ]

    const gotoPage = (key: string) => {
        switch (key) {
            default:
                setEdit(`${key}`);
                break;

            case 'logout':
                presentAlert({
                    header: 'Oops!',
                    message: 'Are you sure you want to logout?',
                    buttons: [
                        { text: 'Cancel' },
                        {
                            text: 'Yes, Log out', handler: () => {
                                setLoading('bye bye...');
                                axius.signout();
                            }
                        }
                    ],
                });
                break;
        }
    }

    return (
        <IonPage id="User">
            <Header {...props} title="Profile" />

            <IonContent fullscreen>
                <IonLoading open={loading ? true : false} message={loading} onCancel={() => setLoading('')} />
                <div className="p-3 text-center fw-600 title m-4">
                    <span className="secondary">YOUR</span> <span className="text-white">PROFILE</span>
                </div>
                <div className="divider" />

                <div className="p-4s">
                    <div>&nbsp;</div>
                    <IonItemGroup className="mt-0">
                        {lists.map((item: any) => (
                            <IonItem key={item.key} button lines="full" className="animate__animated animate__fadeIn" onClick={() => gotoPage(item.key)}>
                                <IonLabel>
                                    <div className="my-1" dangerouslySetInnerHTML={{ __html: item.label }} />
                                </IonLabel>
                            </IonItem>
                        ))}
                    </IonItemGroup>

                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>

                    <div
                        className="text-center muted small"
                        onClick={() => {
                            caches.keys().then(keys => {
                                // console.log(keys); return;
                                Promise.all(keys.map(key => caches.delete(key))).then(() => {
                                    func.redirect('./');
                                });
                            });
                        }}
                    >Republic Dash Rider v{func.app.version}</div>
                </div>

                <Modal open={edit ? true : false} width="90vw" centered title={null} footer={null} destroyOnClose={true} maskClosable={false} onCancel={() => setEdit('')}>
                    {edit === 'profile' && <FormProfile {...props} onSuccess={() => setEdit('')} />}
                    {edit === 'phone' && <FormPhone {...props} onSuccess={() => setEdit('')} />}
                    {edit === 'email' && <FormEmail {...props} onSuccess={() => setEdit('')} />}
                </Modal>
            </IonContent>
        </IonPage>
    );
};

export default User;
